import React from "react";
import classNames from "classnames";
export const SmartTable = (props) => {
    return (React.createElement("div", { className: classNames("smart-table") },
        React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null, props.headings && props.headings.map((item, index) => {
                    return React.createElement("th", { key: index, className: item.className }, item.title);
                }))),
            React.createElement("tbody", null, props.rows && props.rows.map((item, index) => {
                return props.row(item);
            })))));
};
